<template>
  <div>
    <h3>
      Wat is het e-mailadres en de geboortedatum van uw partner?
    </h3>
    <b-row>
      <b-col sm="5" class="form-label">
        <i class="fad fax fa-user"></i>
        <label for="email-partner">E-mailadres</label>
      </b-col>
      <b-col sm="6">
        <b-form-input
                type="email"
                id="email=partner"
                v-model="$v.form.email.$model"
                size="sm"
                placeholder=""
                :state="$v.form.email.$dirty ? !$v.form.email.$invalid : undefined"
        />
      </b-col>
    </b-row>
    <b-row :class="{'is-invalid': ($v.form.dob.$dirty ? $v.form.dob.$invalid : false)}">
      <b-col sm="5" class="form-label">
        <i class="fad fax fa-calendar-star"></i>
        <label for="dob">Geboortedatum*</label>
      </b-col>
      <b-col sm="6">
        <b-row class="date-wrap">
          <b-form-select
                  class="col-3 day-input"
                  v-model="form.dob_day"
                  :options="formData.days"
                  @change="checkDate"
                  required
          />
          <b-form-select
                  class="col-5"
                  v-model="form.dob_month"
                  :options="formData.months"
                  @change="checkDate"
                  required
          />
          <b-form-select
                  class="col-4"
                  v-model="form.dob_year"
                  :options="formData.years"
                  @change="checkDate"
                  required
          />
          <div class="invalid-feedback" v-if="($v.form.dob.$dirty ? $v.form.dob.$invalid : false)">
            Dit moet een bestaande datum van tenminste 18 jaar geleden zijn
          </div>
        </b-row>
      </b-col>
    </b-row>
    <error-box v-if="errors.length" :i18n="true" :errors="errors" />
    <br/>
    <b-row>
      <b-col cols="12">
        <div class="disconnectedButtons">
          <b-button variant="success" size="sm" class=" text-center float-right" @click.stop="findPartner">
            Haal inschrijving op
          </b-button>
          <b-button variant="secondary" size="sm" class="text-center float-right" @click.stop="$emit('skip')">
            Overslaan en later koppelen
          </b-button>
        </div>
      </b-col>
    </b-row>
    <br>
    <b-modal ref="connect-partner-modal" hide-footer title="Partner koppelen">
      <div class="d-block">
        <h3 class="text-center">Wat is de code die uw partner heeft ontvangen?</h3>
        <div class="text-center">
          <input
              v-model="confirmationCode"
              type="text"
              pattern="[0-9][0-9][0-9][0-9][0-9][0-9]"
              maxlength="6"
              placeholder="______"
              id="codeInput"
          >
          <div class="invalid-feedback" v-if="codeIncorrect">
            Verkeerde code
          </div>
        </div>
        <br>
        <b-row>
          <b-col cols="7">
            <p @click.stop="requestPartnerConnection(requestedPartnerGUID)" id="request-code-again">Geen code ontvangen? Vraag opnieuw code aan.</p>
          </b-col>
          <b-col cols="5">

          <b-button variant="success" size="sm" class=" text-center float-right" @click.stop="confirmPartner">
            Bevestig code
          </b-button>
          </b-col>
        </b-row>

        <p>o	Uw partner heeft de code ontvangen op de Woonmatch App. Heeft uw partner geen Woonmatch App? Dan heeft uw partner een e-mail ontvangen met een code. Check eventueel de spam e-mailmap.</p>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { email, required } from 'vuelidate/lib/validators'
import { dobAboveEighteen } from '@/_helpers/validators'
import { getDays, getMonths, getYears } from '../../_helpers'
import { registrationService } from '@/_services/registration.service'
import ErrorBox from '@/components/_registration/ErrorBox'

export default {
  name: 'RetrievePartner',
  components: {ErrorBox},
  data: () => {
    return {
      errors: [],
      requestedPartnerGUID: '',
      partnerNotFound: false,
      codeIncorrect: false,
      form: {
        email: '',
        dob_day: '',
        dob_month: '',
        dob_year: '',
        dob: '',
      },

      activeInput: '',

      formData: {
        days: getDays(),
        months: getMonths(),
        years: getYears(18, 100)
      },

      confirmationCode: '',
    }
  },
  validations: {
    form: {
      email: { required, email },
      dob_month: { required },
      dob_day: { required },
      dob_year: { required },
      dob: { required, dobAboveEighteen },
    },
  },
  methods: {
    setActiveInput (data) {
      if (data !== this.activeInput) {
        this.activeInput = data
      }
    },

    checkDate () {
      if (this.form.dob_day !== '' && this.form.dob_month !== '' && this.form.dob_year !== '') {
        this.form.dob = this.form.dob_year + '-' + this.form.dob_month + '-' + this.form.dob_day
        this.$v.form.dob.$touch()
      }
    },

    findPartner () {
      this.$v.form.$touch()
      if (this.$v.$invalid) {
        return
      }
      let data = {
        dob: this.form.dob,
        email: this.form.email
      }

      registrationService.findPartnerRegistration(data)
              .then(response => {
                if (response.status !== 200 && response.status !== 400) {
                  this.partnerNotFound = true
                  throw Error(response.statusText)
                }
                return response.json()
              })
              .then(data => {
                if('errors' in data){
                  this.errors = data.errors
                  this.partnerNotFound = true
                } else {
                  this.requestPartnerConnection(data.id)
                }
              })
              .catch(error => console.log(error))
    },

    requestPartnerConnection (guid) {
      this.requestedPartnerGUID = guid
      registrationService.requestPartnerConnection(guid)
              .then(response => {
                if (response.status !== 200) {
                  this.partnerNotFound = true
                  throw Error(response.statusText)
                }
                return response.json()
              })
              .then(data => {
                this.$refs['connect-partner-modal'].show()
              })
              .catch(error => console.log(error))
    },

    confirmPartner(){

      registrationService.confirmPartnerConnection(this.confirmationCode)
              .then(response => {
                if (response.status !== 200) {
                  this.codeIncorrect = true
                  throw Error(response.statusText)
                }
                return response.json()
              })
              .then(data => {
                this.$emit('partnerConnected')
              })
              .catch(error => console.log(error))
    },
  }
}
</script>
<style scoped>
  #request-code-again{
    color: #ff00ff;
    cursor: pointer;
    text-decoration: underline;
    font-size: 11px;
  }
  #request-code-again:hover{
    color: #d004d0;
  }
  #codeInput {
    letter-spacing: 25px;
    font-size: 24px;
    padding: 10px 0 10px 35px;
  }
  #codeInput::-webkit-input-placeholder {
    text-align: center;
  }

</style>